export default {
  /** すべて */
  ALL: 'all',
  /** ゴミ箱 */
  TRASH: 'trash',
}
